import React from "react"
import { Link } from "gatsby"

import FacioLogoAlternative from "assets/logos/facio-alternative.svg"

import { footer, grid, logo, help, links, footerList } from "./footer.module.css"

const FooterShort = ({ phoneNumber }) => {
  return (
    <footer className={footer}>
      <div className="wrapper">
        <div className={grid}>
          <FacioLogoAlternative className={logo} />

          <div className={links}>
            <div>
              <h4>Precisa de ajuda?</h4>
              <p>Chama a gente no Whatsapp</p>
              <p>
                <a
                  href={`https://web.whatsapp.com/send?phone=55${
                    phoneNumber ? phoneNumber.replace(/\(*\)*-*\s*/g, "") : 1140405509
                  }`}
                >
                  {phoneNumber || `(11) 4040-5509`}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default FooterShort
